import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/axiosAuth";

export const fetchItemCostCategories = createAsyncThunk(
  "itemCostCategories/",
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`/api/itemCostCategories/`);
      return { rows: response.data || [] };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const itemCostCategoriesSlice = createSlice({
  name: "itemCostCategories",
  initialState: { rows: [], status: "idle", error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchItemCostCategories.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchItemCostCategories.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.rows = action.payload.rows;
      })
      .addCase(fetchItemCostCategories.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "حدث خطأ غير متوقع";
      });
  },
});

export default itemCostCategoriesSlice.reducer;
export const selectitemCostCategoriesRows = (state) =>
  state.itemCostCategories.rows;
export const selectitemCostCategoriesStatus = (state) =>
  state.itemCostCategories.status;
export const selectitemCostCategoriesError = (state) =>
  state.itemCostCategories.error;
